import { useRetainedAppState } from './useRetainedAppState';

export const DefaultPage: React.FC = () => {
    useRetainedAppState();

    return <></>;
};
